import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.progressBar = this.createProgressBar()
        this.handleScroll = this.handleScroll.bind(this)
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        this.handleScroll() // Initial calculation
    }

    disconnect() {
        window.removeEventListener('scroll', this.handleScroll)
        if (this.progressBar && this.progressBar.parentNode) {
            this.progressBar.remove()
        }
    }

    createProgressBar() {
        const bar = document.createElement('div')
        bar.className = 'reading-progress-bar'
        bar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 0%;
      height: 4px;
      background: linear-gradient(to right, #3b8ff6, #1d71d8);
      z-index: 9999;
      transition: width 0.1s ease-out;
    `
        document.body.appendChild(bar)
        return bar
    }

    handleScroll() {
        const windowHeight = window.innerHeight
        const documentHeight = document.documentElement.scrollHeight
        const scrollTop = window.scrollY

        // Calculate progress percentage
        const scrollableHeight = documentHeight - windowHeight
        const progress = (scrollTop / scrollableHeight) * 100

        // Update progress bar width
        this.progressBar.style.width = `${Math.min(progress, 100)}%`
    }
}